var React = require('react');

function DataEncryptedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 0h12v4H18V0zm-8 12V4h8v4h-4v4h-4zm0 0v8h12v4H0v-4h6v-8h4zm28 0h-4V8h-4V4h8v8zm0 0h4v8h6v4H26v-4h12v-8zM0 28h8v4H0v-4zm0 12v-4h36v4H0zm22 4H0v4h22v-4zm26 0H26v4h22v-4zm0-8h-8v4h8v-4zm0-8H12v4h36v-4z","fill":"#9A77FF"}));
}

DataEncryptedIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DataEncryptedIcon;

DataEncryptedIcon.default = DataEncryptedIcon;
